'use strict';

var _ = require('lodash');
var $ = require('jquery');
var SimpleGridDirective = function SimpleGridDirective() {
  return {
    restrict: 'E',
    replace: true,
    controller: 'SimpleGridController',
    template: require('../templates/simple-grid.html'),
    scope: {
      data: '=',
      dynamicColumns: '=',
      customDisplayModel: '=',
      selectCallback: '=',
      collapseCallback: '=',
      settings: '=',
      statusDetails: '='
    },
    link: function link($scope, element) {
      $scope.lastTooltip = '';
      var gridContentTemplate = _.template(require('../templates/simple-grid-body.html'));
      var $gridElement = element.find('table.rm-simple-grid');
      var $window = $(window);
      function calculateTooltipPosition(targetDimension) {
        return {
          offset: {
            left: targetDimension.left + $window.scrollLeft(),
            top: targetDimension.top + $window.scrollTop()
          },
          width: targetDimension.width,
          height: targetDimension.height
        };
      }
      $scope.hideTooltip = function () {
        if ($scope.featureEnabled('tooltips')) {
          $scope.$broadcast('simple-grid-tooltip:hide');
          $scope.lastTooltip = '';
        }
      };
      $scope.getRowForTooltip = function (triggerCell) {
        var groupIndex = parseInt(triggerCell.getAttribute('data-group-index'));
        var rowIndex = parseInt(triggerCell.getAttribute('data-row-index'));
        if (!_.isNaN(groupIndex) && !_.isNaN(rowIndex)) {
          return _.get($scope, 'data[' + groupIndex + '].groupedRows[' + rowIndex + ']');
        } else if (!_.isNaN(rowIndex)) {
          return $scope.data[rowIndex];
        } else if (!_.isNaN(groupIndex)) {
          return $scope.data[groupIndex];
        }
        return undefined;
      };
      $scope.showTooltip = function (event) {
        var tooltips = $scope.featureEnabled('tooltips');
        if (!tooltips) {
          return;
        }
        var groupedModeTooltips = $scope.featureEnabled('groupedModeTooltips');
        var triggerCell = event && event.currentTarget;
        var fieldName = triggerCell.getAttribute('data-field-name');
        var tooltipBuilder = tooltips[fieldName];
        var dataRow = $scope.getRowForTooltip(triggerCell);
        var isCollapsed = undefined;
        if ($scope.featureEnabled('grouping') && groupedModeTooltips && groupedModeTooltips[fieldName]) {
          var groupIndex = parseInt(event.target.getAttribute('data-group-index'));
          var group = $scope.data[groupIndex];
          isCollapsed = group.isCollapsed;
          if (group && group.isCollapsed) {
            tooltipBuilder = groupedModeTooltips[fieldName];
          }
        }
        var selectiveTooltipRender = $scope.featureEnabled('selectiveTooltipRender');
        var shouldRenderToolTip = selectiveTooltipRender && selectiveTooltipRender[fieldName];
        if (shouldRenderToolTip && !shouldRenderToolTip(dataRow, isCollapsed)) {
          return;
        }
        if (_.isFunction(tooltipBuilder)) {
          var targetDimensions = triggerCell.getBoundingClientRect();
          var tooltipId = [targetDimensions.top, targetDimensions.left, targetDimensions.width].join(',');
          if ($scope.lastTooltip !== tooltipId) {
            var tooltipPosition = triggerCell.getAttribute('data-tooltip-placement');
            $scope.$broadcast('simple-grid-tooltip:hide');
            $scope.lastTooltip = tooltipId;
            var tooltipData = {
              htmlContent: tooltipBuilder(dataRow),
              targetPosition: calculateTooltipPosition(targetDimensions),
              placement: tooltipPosition ? tooltipPosition : 'top'
            };
            $scope.$broadcast('simple-grid-tooltip:show', tooltipData);
          }
        }
      };
      $scope.renderStatusPopup = function (event) {
        var groupIndex = event.currentTarget.getAttribute('data-group-index');
        var data_row = $scope.data[groupIndex];
        var data = {
          status: data_row.status,
          remarks: data_row.remarks,
          authorizationNotes: data_row.authorizationNotes,
          fareBasisCode: data_row.fbc,
          lastUpdatedBy: data_row.lastUpdatedBy,
          eventTimeStamp: data_row.eventTimeStamp,
          approvalDateTime: data_row.approvalDateTime,
          recommendationEffectiveDate: data_row.recommendationEffectiveDate,
          fareRecommendationRecordKey: data_row.fareRecommendationRecordKey,
          market: data_row.market,
          foCabin: data_row.cabin,
          pos: data_row.pos,
          rejectionExpiryDateTime: data_row.rejectionExpiryDateTime,
          ladderRemarks: data_row.ladderRemarks
        };
        var maxApprovalDate = $scope.featureEnabled('maxApprovalDateRetriever');
        if (maxApprovalDate && _.isFunction(maxApprovalDate.getApprovalDate)) {
          data.maxApprovalDate = maxApprovalDate.getApprovalDate(data_row);
        }
        $scope.statusDetails.data = data;
        $scope.statusDetails.showPopup = true;
        $scope.$apply();
      };
      $scope.groupSelect = function (event) {
        var groupIndex = parseInt(event.target.getAttribute('data-group-index'));
        var group = $scope.data[groupIndex];
        if ($scope.settings.multiSelect !== undefined && $scope.settings.multiSelect === true) {
          handleMultiSelect(group);
        } else {
          handleSingleSelect(group);
        }
        if ($scope.headerCheckboxSelected === false) {
          if (_.every($scope.data, ['selected', true])) {
            $scope.headerCheckboxSelected = true;
          }
        }
        $scope.$apply();
        $scope.renderGrid();
      };
      function handleMultiSelect(group) {
        if (group) {
          $scope.headerCheckboxSelected = false;
          group.selected = !group.selected;
          _.forEach(group.groupedRows, function (row) {
            row.selected = group.selected;
          });
        } else {
          _.forEach($scope.data, function (row) {
            row.selected = $scope.headerCheckboxSelected;
            _.forEach(row.groupedRows, function (groupedRow) {
              groupedRow.selected = $scope.headerCheckboxSelected;
            });
          });
        }
        if (_.isFunction($scope.selectCallback)) {
          $scope.selectCallback(group);
        }
      }
      function handleSingleSelect(group) {
        _.forEach($scope.data, function (row) {
          if (row.selected !== undefined && row.selected) {
            row.selected = false;
          }
        });
        if (group) {
          group.selected = !group.selected;
          _.forEach(group.groupedRows, function (row) {
            row.selected = group.selected;
          });
          if (_.isFunction($scope.selectCallback)) {
            $scope.selectCallback(group);
          }
        }
      }
      $scope.groupCollapse = function (event) {
        var groupIndex = parseInt(event.target.getAttribute('data-group-index'));
        var group = $scope.data[groupIndex];
        if (group) {
          group.isCollapsed = !group.isCollapsed;
          if (_.isFunction($scope.collapseCallback)) {
            $scope.collapseCallback(group);
          }
        }
        $scope.$apply();
        $scope.renderGrid();
      };
      $gridElement.on('mousemove', '.grid-content-cell', $scope.showTooltip);
      $gridElement.on('mouseout', $scope.hideTooltip);
      $gridElement.on('click', '.btn-expand-collapse-row', $scope.groupCollapse);
      $gridElement.on('click', '.group-select-checkbox', $scope.groupSelect);
      $gridElement.on('click', '.link-render', $scope.renderStatusPopup);
      element.on('$destroy', function () {
        $gridElement.off('mousemove', $scope.showTooltip);
        $gridElement.off('mouseout', $scope.hideTooltip);
        $gridElement.off('click');
      });
      $scope.renderGrid = function () {
        $scope.resetContent();
        var tablePlaceholder = $gridElement.find('.grid-body-template-placeholder');
        var html = gridContentTemplate($scope);
        tablePlaceholder.replaceWith(html);
      };
      $scope.resetContent = function () {
        $gridElement.find('tbody').remove();
        $gridElement.append('<tbody class="grid-body-template-placeholder"></tbody>');
      };
      $scope.$on('simple-grid:force-refresh', $scope.renderGrid);
    }
  };
};
SimpleGridDirective.$inject = [];
module.exports = SimpleGridDirective;